import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getSales = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/sales?${queryParts.join("&")}`;
  const { data: sales } = await axios.get(url);
  return sales;
};

export const removeSale = async (saleId) => {
  const { data: removedSale } = await axios.delete(`/sales/${saleId}`);
  return removedSale;
};

export const addSale = async (sale) => {
  const { data: addedSale } = await axios.post(`/sales`, {
    data: sale,
  });
  return addedSale;
};

export const updateSale = async ({ id, ...saleData }) => {
  const { data: updatedSale } = await axios.put(`/sales/${id}`, {
    data: saleData,
  });
  return updatedSale;
};
